export enum EFieldGroupType {
  FIELD_GROUP = 1,
  SERVICE = 2,
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/enums/e-field-group-type.enum.ts